import * as angular from "angular";
import { DialogUtils } from "../../../helper/dialog.helper";
import { User } from "../../../models/user.model";

let AppointmentAssigneeComponent = {
    selector: "vcAppointmentAssignee",
    templateUrl:
        "/angular/components/planner/modals/appointment-assignee.component.html",
    bindings: {
        assignee: "=",
    },
    controller: class CreateGroupController {
        // * bindings for typescript compiler *
        public assignee: User;
        // ************************************
        private dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        cancel(): void {
            this.dialog.cancel();
        }

        save(): void {
            this.dialog.hide(this.assignee);
        }
    },
};

angular
    .module("planner", [])
    .component(
        AppointmentAssigneeComponent.selector,
        AppointmentAssigneeComponent
    );
